var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn vld-parent custom-100"},[_c('iframe',{attrs:{"src":"https://bisoffice.net"}})])}]

export { render, staticRenderFns }